export default __webpack_public_path__ + "static/media/touchThree.e3ba151a.svg";